<template>
  <div class="koc-block koc-event-card-block">
    <div class="koc-event-card-container">
      <div class="koc-event-card-image-container">
        <div
          v-if="state.showRibbonBar(userEvents)"
          :class="state.ribbonBarColorClass(userEvents)"
          class="koc-ribbon koc-ribbon-top-right"
        >
          <span>{{ state.ribbonText(userEvents) }}</span>
        </div>
        <a
          :href="state.event.url"
          class="koc-event-card-image-link"
        >
          <img :src="event.image">
        </a>
        <div
          v-if="state.showRibbonBar(userEvents)"
          :class="state.ribbonBarColorClass(userEvents)"
          class="koc-event-card-color-bar"
        />
      </div>
      <div class="koc-event-card-body">
        <div class="koc-event-card-title">
          <a
            :href="state.event.url"
            class="koc-title-2 koc-event-card-title-link"
          >
            {{ event.name }}
          </a>
        </div>
        <div class="koc-body-1">
          {{ state.headerDateText(userEvents) }}
        </div>
      </div>
      <div class="koc-event-card-actions">
        <div class="koc-event-card-action-text-container">
          <span v-if="state.showLearnMore(userEvents)"><a
            :href="state.event.url"
            class="koc-title-3 koc-event-card-action-text koc-link"
          >learn more </a></span>
          <span v-if="state.showLearnMore(userEvents)">or</span>
          <span>
            <a
              :class="state.actionClass(userEvents)"
              :href="state.actionUrl(userEvents)"
              class="koc-title-3 koc-event-card-action-text"
            >{{ state.actionText(userEvents) }}</a>
          </span>
          <span
            v-if="state.showPipe(userEvents)"
            class="koc-title-3 koc-event-card-action-text koc-pipe"
          >|</span>
          <span
            v-if="state.showActionDateText(userEvents)"
            class="koc-title-3 koc-event-card-action-text koc-event-card-expires-text"
          >{{ state.actionDateText(userEvents) }}</span>
          <span
            v-if="state.showPrice(userEvents)"
            :class="{ 'koc-line-through' : state.onSale}"
            class="koc-title-3 koc-event-card-action-text"
          >{{ formatPrice(state.event.price) }}</span>
          <span
            v-if="state.showPrice(userEvents) && state.onSale"
            class="koc-title-3 koc-event-card-action-text koc-sale"
          >{{ formatPrice(state.salePrice) }}</span>
        </div>
        <div
          v-if="state.showLoginLink(userEvents, user)"
          class="koc-body-1 koc-event-card-action-login"
        >
          Already Purchased? <a
            class="koc-secondary-text"
            href="javascript:void(0);"
            @click="login"
          >Log in here</a>
        </div>
        <span
          v-if="state.detailsUrl"
          class="koc-event-price-box-live-event-info"
        ><a
          class="koc-title-3 koc-event-card-action-text koc-link"
          target="_blank"
          :href="state.detailsUrl"
        >view in-person event info</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script src="./event-card.js"></script>
<style lang="scss" scoped src="./event-card.scss"></style>
